import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaw,
  faWalking,
  faTaxi,
  faGift,
  faStar,
  faMedal,
  faHandshake,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import QuickServices from "../../components/dashboard/QuickService";
import InviteButton from "../../components/InviteButton";
import LoadingLogo from "../../components/Loading";
import api from "../../api/api";
import { toast } from "react-toastify";
import { routes } from "../../config/utility";
import DashboardPromoCode from "../../components/DashboardPromoCode";
// import useSocket from "../../hooks/useSocket";

const PetOwnerDashboard = () => {
  const [isPromotionOpen, setPromotionOpen] = useState(true);
  const closeModal = () => setPromotionOpen(false);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});

  // Sample data for recharts
  // const bookingTrendsData = [
  //   { day: "Mon", Walks: 20, Deliveries: 15 },
  //   { day: "Tue", Walks: 30, Deliveries: 25 },
  //   { day: "Wed", Walks: 40, Deliveries: 35 },
  //   { day: "Thu", Walks: 25, Deliveries: 30 },
  //   { day: "Fri", Walks: 50, Deliveries: 40 },
  //   { day: "Sat", Walks: 65, Deliveries: 55 },
  //   { day: "Sun", Walks: 45, Deliveries: 60 },
  // ];

  // const engagementData = [
  //   { day: "Mon", engagement: 20 },
  //   { day: "Tue", engagement: 30 },
  //   { day: "Wed", engagement: 40 },
  //   { day: "Thu", engagement: 25 },
  //   { day: "Fri", engagement: 50 },
  //   { day: "Sat", engagement: 65 },
  //   { day: "Sun", engagement: 45 },
  // ];

  // const membershipDistributionData = [
  //   { name: "Silver", value: 60 },
  //   { name: "Gold", value: 25 },
  //   { name: "Platinum", value: 15 },
  // ];

  // const walkTimesData = [
  //   { time: "6 AM", walks: 5 },
  //   { time: "9 AM", walks: 20 },
  //   { time: "12 PM", walks: 30 },
  //   { time: "3 PM", walks: 25 },
  //   { time: "6 PM", walks: 15 },
  // ];

  // const COLORS = ["#D8B4FE", "#7C3AED", "#9A48FF"];

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await api.get("/home");
      setData(response.data);
      setLoading(false);
    } catch (error) {
      toast.error("Failed to fetch data.");
      setLoading(false);
    }
  };




  if (loading) {
    return <LoadingLogo />;
  }



  return (
    <div className=" sm:space-y-8">

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[
          // {
          //   label: "Total Spent",
          //   count: data.total_spent + " " + CURRENCY_CODE,
          //   icon: faPaw,
          //   color: "text-primary",
          //   gradient: "bg-white",
          //   highlight: true,
          // },
          {
            label: "Membership",
            count: data.membership?.name,
            icon: faStar,
            color: "text-yellow-500",
            gradient: "bg-white",
            highlight: true,
          },
          {
            label: "Total Walks",
            count: data.total_walks,
            icon: faWalking,
            color: "text-primary",
            gradient: "bg-white",
          },
          {
            label: "Total Taxi",
            count: data.total_deliveries,
            icon: faTaxi,
            color: "text-accent",
            gradient: "bg-white",
          },

        ].map((item, idx) => (
          <motion.div
            key={idx}
            className={`relative px-6 py-8 rounded-xl shadow-lg transform transition-transform hover:scale-105 ${item.gradient} text-white`}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.2 }}
          >
            {item.highlight && (
              <div className="absolute -top-3 -left-3 bg-gradient-to-r from-primary to-accent text-white text-xs px-3 py-1 rounded-full shadow-md flex items-center space-x-1">
                <FontAwesomeIcon icon={faMedal} />
                <span>Featured</span>
              </div>
            )}

            <div className="flex items-center space-x-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white bg-opacity-20">
                <FontAwesomeIcon
                  icon={item.icon}
                  className={`text-4xl ${item.color}`}
                />
              </div>
              <div>
                <h4 className="text-3xl text-tblue font-bold">{item.count}</h4>
                <p className="text-lg text-tblue">{item.label}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>


      {
        (data.ongoing_walk || data.ongoing_delivery) && (
          <section>
            {/* <h2 className="text-2xl font-bold text-tblue mb-4">🚀 Ongoing Walk & Delivery</h2> */}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
              {/* Ongoing Walk */}
              {data.ongoing_walk && (
                <motion.div
                  className="relative bg-gradient-to-l from-secondary to-light text-tblue  p-6 rounded-2xl shadow-2xl flex items-center space-x-6 overflow-hidden"
                  whileHover={{ scale: 1.05 }}
                >
                  {/* Glowing Circle */}
                  <div className="absolute w-8 h-8 bg-tblue rounded-full blur-3xl -top-6 -left-6"></div>

                  {/* Icon */}
                  <div className="bg-tblue bg-opacity-90 p-4 rounded-full shadow-lg backdrop-blur-md flex items-center justify-center w-14 h-14">
                    <FontAwesomeIcon icon={faWalking} className="text-3xl text-white" />
                  </div>

                  {/* Details */}
                  <div>
                    <h3 className="text-lg font-semibold">🐾 Ongoing Walk</h3>
                    <p className="text-sm">Status: <span className="font-bold">{data.ongoing_walk.status}</span></p>
                    <p className="text-sm">Duration: <span className="font-bold">{data.ongoing_walk.duration}</span></p>
                    <p className="text-sm">Emergency No: <span className="font-bold">{data.ongoing_walk.emergency_no}</span></p>
                  </div>
                </motion.div>
              )}

              {/* Ongoing Delivery */}
              {data.ongoing_delivery && (
                <motion.div
                  className="relative  bg-gradient-to-r from-secondary to-light text-tblue p-6 rounded-2xl shadow-2xl flex items-center space-x-6 overflow-hidden"
                  whileHover={{ scale: 1.05 }}
                >
                  {/* Glowing Circle */}
                  <div className="absolute w-8 h-8 bg-tblue rounded-full blur-3xl -top-6 -right-6"></div>


                  {/* Icon */}
                  <div className="bg-tblue bg-opacity-90 p-4 rounded-full shadow-lg backdrop-blur-md flex items-center justify-center w-14 h-14">
                    <FontAwesomeIcon icon={faTaxi} className="text-3xl text-white" />
                  </div>

                  {/* Details */}
                  <div>
                    <h3 className="text-lg font-semibold">🚖 Ongoing Taxi</h3>
                    <p className="text-sm">Status: <span className="font-bold">{data.ongoing_delivery.status}</span></p>
                    <p className="text-sm">Distance: <span className="font-bold">{data.ongoing_delivery.google.distance}</span></p>
                    <p className="text-sm">Duration: <span className="font-bold">{data.ongoing_delivery.google.duration}</span></p>
                  </div>
                </motion.div>
              )}
            </div>
          </section>)}

      {
        (data.scheduled_walks?.length > 0 || data.scheduled_deliveries?.length > 0) && (
          <section>
            {/* <h2 className="text-2xl font-bold text-tblue mb-6">📅 Scheduled Walks & Deliveries</h2> */}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Scheduled Walks */}
              {data.scheduled_walks.length > 0 && (
                <motion.div
                  className="relative bg-gradient-to-r from-primary to-accent text-white p-6 rounded-2xl shadow-2xl flex flex-col space-y-4"
                  whileHover={{ scale: 1.05 }}
                >
                  {/* Glowing Effect */}
                  <div className="absolute w-32 h-32 bg-white/20 rounded-full blur-3xl -top-6 -left-6"></div>

                  {/* Header */}
                  <div className="flex items-center space-x-3">
                    <FontAwesomeIcon icon={faPaw} className="text-4xl text-white" />
                    <h3 className="text-xl font-semibold">Scheduled Walks</h3>
                  </div>

                  {/* List of Walks */}
                  {data.scheduled_walks.map((walk) => (
                    <div key={walk.id} className="p-4 bg-white bg-opacity-20 rounded-xl shadow-lg backdrop-blur-lg">
                      <p className="text-sm">
                        <FontAwesomeIcon icon={faClock} className="mr-2" />
                        Time Left: <span className="font-bold">{walk.time_remaining}</span>
                      </p>
                      <p className="text-sm">Total: <span className="font-bold">{walk.total} AED</span></p>
                      <p className="text-sm">Status: <span className="font-bold">{walk.status}</span></p>

                      {/* Pet Images with Overlay */}
                      <div className="flex space-x-2 mt-3">
                        {walk.pets.map((pet) => (
                          <div key={pet.id} className="relative group">
                            <img src={pet.primary_image_url} alt={pet.name} className="w-12 h-12 rounded-full border border-white shadow-md" />
                            <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-70 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition">
                              {pet.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </motion.div>
              )}

              {/* Scheduled Deliveries */}
              {data.scheduled_deliveries.length > 0 && (
                <motion.div
                  className="relative bg-gradient-to-r from-gradientStart to-gradientEnd text-white p-6 rounded-2xl shadow-2xl flex flex-col space-y-4"
                  whileHover={{ scale: 1.05 }}
                >
                  {/* Glowing Effect */}
                  <div className="absolute w-32 h-32 bg-white/20 rounded-full blur-3xl -top-6 -left-6"></div>

                  {/* Header */}
                  <div className="flex items-center space-x-3">
                    <FontAwesomeIcon icon={faTaxi} className="text-4xl text-white" />
                    <h3 className="text-xl font-semibold">Scheduled Deliveries</h3>
                  </div>

                  {/* List of Deliveries */}
                  {data.scheduled_deliveries.map((delivery) => (
                    <div key={delivery.id} className="p-4 bg-white bg-opacity-20 rounded-xl shadow-lg backdrop-blur-lg">
                      <p className="text-sm">
                        <FontAwesomeIcon icon={faClock} className="mr-2" />
                        Time Left: <span className="font-bold">{delivery.time_remaining}</span>
                      </p>
                      <p className="text-sm">Total: <span className="font-bold">{delivery.total} AED</span></p>
                      <p className="text-sm">Status: <span className="font-bold">{delivery.status}</span></p>

                      {/* Pet Images with Overlay */}
                      <div className="flex space-x-2 mt-3">
                        {delivery.pets.map((pet) => (
                          <div key={pet.id} className="relative group">
                            <img src={pet.primary_image_url} alt={pet.name} className="w-12 h-12 rounded-full border border-white shadow-md" />
                            <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-70 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition">
                              {pet.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </motion.div>
              )}
            </div>
          </section>
        )}


      <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
        <div className="md:col-span-12 ">
          <QuickServices />
        </div>
      </div>

      {/* Charts and Graphs Section */}
      {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 mt-6"> */}
      {/* Booking Trends Line Chart */}
      {/* <div className="bg-white p-6 rounded-lg shadow-lg">
          <h3 className="text-lg font-semibold text-tblue mb-4">
            Weekly Booking Trends
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={bookingTrendsData}>
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis dataKey="day" />
              <YAxis />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="Walks"
                stroke="#7C3AED"
                strokeWidth={3}
              />
              <Line
                type="monotone"
                dataKey="Deliveries"
                stroke="#D8B4FE"
                strokeWidth={3}
              />
            </LineChart>
          </ResponsiveContainer>
        </div> */}

      {/* Membership Distribution Pie Chart */}
      {/* <div className="bg-white p-6 rounded-lg shadow-lg">
          <h3 className="text-lg font-semibold text-tblue mb-4">
            {" "}
            Pet’s Engagement Tracker{" "}
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <ScatterChart>
              <CartesianGrid />
              <XAxis dataKey="day" />
              <YAxis dataKey="engagement" />
              <Tooltip cursor={{ strokeDasharray: "3 3" }} />
              <Scatter data={engagementData} fill="#7C3AED" />
            </ScatterChart>
          </ResponsiveContainer>
        </div> */}

      {/* Pet’s Favorite Walk Times Area Chart */}
      {/* <div className="bg-white p-6 rounded-lg shadow-lg">
          <h3 className="text-lg font-semibold text-tblue mb-4">
            Pet’s Favorite Walk Times
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <AreaChart data={walkTimesData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="time" />
              <YAxis />
              <Tooltip />
              <defs>
                <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#7C3AED" stopOpacity={0.8} />
                  <stop offset="95%" stopColor="#7C3AED" stopOpacity={0} />
                </linearGradient>
              </defs>
              <Area
                type="monotone"
                dataKey="walks"
                stroke="#7C3AED"
                fill="url(#colorUv)"
              />
            </AreaChart>
          </ResponsiveContainer>
        </div> */}
      {/* </div> */}

      {/* Bottom Promotional Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mt-4">
        {/* Invite Friends Section */}
        <div className="bg-gradient-to-r from-primary to-accent text-white p-4 sm:p-6 rounded-lg shadow-lg flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-center sm:text-left">
            <h3 className="text-lg font-semibold mb-1">Invite Your Friends 🎉</h3>
            <p className="text-sm sm:text-base">Book walks for your pets together!</p>
          </div>
          <InviteButton />
        </div>

        {/* Promotion Section */}
        <DashboardPromoCode />
      </div>

      {/* 🏆 Recommended Partners Section */}
      <section>
        <h2 className="text-2xl font-bold text-tblue">🐶 Recommended Partners</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
          {data.partners?.map((partner) => (
            <div
              key={partner.id}
              className="min-w-[280px] md:min-w-[320px] lg:min-w-[360px] bg-white shadow-lg rounded-xl p-6 flex items-center space-x-4 border border-gray-200 hover:shadow-xl transition-transform transform hover:scale-105 snap-center"
            >
              {/* Partner Icon */}
              <div className=" text-white rounded-full shadow-lg flex items-center justify-center w-12 h-12">

                {partner.image_url ? (
                  <img
                    src={partner.image_url}
                    alt={partner.name}
                    className="w-12 h-12 object-cover rounded-full"
                  />
                ) : (
                  <FontAwesomeIcon icon={faHandshake} className="text-2xl" />
                )}
              </div>

              {/* Partner Info */}
              <div>
                <h3 className="font-semibold text-lg">{partner.name}</h3>
                <p className="text-sm text-gray-600 line-clamp-2">{partner.description}</p>
                <a href={routes.delivery} target="_blank" className="text-blue-500 hover:text-blue-700 font-semibold mt-2 block">
                  Book Now →
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>



      {/* Footer Promotional Section */}
      {/* <div className="bg-gradient-to-br from-gradientStart to-gradientEnd text-white p-4 rounded-lg shadow-lg text-center mt-6">
        <h3 className="text-lg font-bold">Exclusive Promotions!</h3>
        <p className="text-sm mt-2">
          Unlock special discounts on bookings by sharing your experiences on
          social media. 🐕
        </p>
        <button className="mt-4 bg-white text-primary px-4 py-2 rounded-lg hover:bg-light hover:text-tblue transition">
          Share Now
        </button>
      </div> */}
    </div >
  );
};

export default PetOwnerDashboard;
